import { AgendaCategory } from "./AgendaCategory";
import { BeforeAfterCategory } from "./BeforeAfterCategory";
import { BiographyCategory } from "./BiographyCategory";
import { ChartCategory } from "./ChartCategory";
import { CompareItemsCategory } from "./CompareItemsCategory";
import { CompareValuesCategory } from "./CompareValuesCategory";
import { ContactInfoCategory } from "./ContactInfoCategory";
import { DashboardCategory } from "./DashboardCategory";
import { CycleDiagramCategory } from "./Diagram-CycleCategory";
import { HierarchyDiagramCategory } from "./Diagram-HierarchyCategory";
import { LinearDiagramCategory } from "./Diagram-LinearCategory";
import { FlowChartCategory } from "./FlowChartCategory";
import { FunnelCategory } from "./FunnelCategory";
import { HeadlineCategory } from "./HeadlineCategory";
import { HeatMapCategory } from "./HeatMapCategory";
import { ListCategory } from "./ListCategory";
import { LogoGridCategory } from "./LogoGridCategory";
import { OrgChartCategory } from "./OrgChartCategory";
import { PhotosWithTextCategory } from "./PhotosWithTextCategory";
import { PillarCategory } from "./PillarCategory";
import { QuadrantChartCategory } from "./QuadrantChartCategory";
import { QuoteCategory } from "./QuoteCategory";
import { SWOTCategory } from "./SWOTCategory";
import { TableCategory } from "./TableCategory";
import { TargetCategory } from "./TargetCategory";
import { TeamCategory } from "./TeamCategory";
import { TextCategory } from "./TextCategory";
import { TimelineCategory } from "./TimelineCategory";
import { TitleCategory } from "./TitleCategory";
import { VennDiagramCategory } from "./VennDiagramCategory";
import { PhotoCategory } from "./PhotoCategory";
import { SectionBreakCategory } from "./SectionBreakCategory";

export const SlideCategories = {
    TITLE: "title",
    TEXT: "text",
    LIST: "list",
    QUOTE: "quote",
    HEADLINE: "headline",
    DASHBOARD: "dashboard",
    SWOT: "swot",
    PILLAR: "pillar",
    COMPARE_ITEMS: "compare_items",
    COMPARE_VALUES: "compare_values",
    ORG_CHART: "org_chart",
    HEAT_MAP: "heatmap",
    TABLE: "table",
    TIMELINE: "timeline",
    LINEAR_DIAGRAM: "linear_diagram",
    CYCLE_DIAGRAM: "cycle_diagram",
    BEFORE_AFTER: "before_after",
    PHOTO: "photo",
    PHOTOS_WITH_TEXT: "photos_with_text",
    TEAM: "team",
    BIOGRAPHY: "biography",
    CHART: "chart",
    QUADRANT_CHART: "quadrant_chart",
    FUNNEL: "funnel",
    FLOWCHART: "flowchart",
    AGENDA: "agenda",
    TARGET: "target",
    HIERARCHY_DIAGRAM: "hierarchy_diagram",
    CONTACT_INFO: "contact_info",
    LOGO_GRID: "logo_grid",
    VENN_DIAGRAM: "venn_diagram",
    SECTION_BREAK: "section_break",
};

export class CategoryController {
    static getCategory(type) {
        switch (type) {
            case SlideCategories.LIST:
                return new ListCategory();
            case SlideCategories.SWOT:
                return new SWOTCategory();
            case SlideCategories.PILLAR:
                return new PillarCategory();
            case SlideCategories.ORG_CHART:
                return new OrgChartCategory();
            case SlideCategories.HEAT_MAP:
                return new HeatMapCategory();
            case SlideCategories.QUOTE:
                return new QuoteCategory();
            case SlideCategories.HEADLINE:
                return new HeadlineCategory();
            case SlideCategories.COMPARE_VALUES:
                return new CompareValuesCategory();
            case SlideCategories.TEXT:
                return new TextCategory();
            case SlideCategories.TITLE:
                return new TitleCategory();
            case SlideCategories.TABLE:
                return new TableCategory();
            case SlideCategories.TIMELINE:
                return new TimelineCategory();
            case SlideCategories.LINEAR_DIAGRAM:
                return new LinearDiagramCategory();
            case SlideCategories.CYCLE_DIAGRAM:
                return new CycleDiagramCategory();
            case SlideCategories.BEFORE_AFTER:
                return new BeforeAfterCategory();
            case SlideCategories.PHOTO:
                return new PhotoCategory();
            case SlideCategories.PHOTOS_WITH_TEXT:
                return new PhotosWithTextCategory();
            case SlideCategories.TEAM:
                return new TeamCategory();
            case SlideCategories.BIOGRAPHY:
                return new BiographyCategory();
            case SlideCategories.CHART:
                return new ChartCategory();
            case SlideCategories.DASHBOARD:
                return new DashboardCategory();
            case SlideCategories.QUADRANT_CHART:
                return new QuadrantChartCategory();
            case SlideCategories.FUNNEL:
                return new FunnelCategory();
            case SlideCategories.FLOWCHART:
                return new FlowChartCategory();
            case SlideCategories.AGENDA:
                return new AgendaCategory();
            case SlideCategories.TARGET:
                return new TargetCategory();
            case SlideCategories.HIERARCHY_DIAGRAM:
                return new HierarchyDiagramCategory();
            case SlideCategories.CONTACT_INFO:
                return new ContactInfoCategory();
            case SlideCategories.LOGO_GRID:
                return new LogoGridCategory();
            case SlideCategories.VENN_DIAGRAM:
                return new VennDiagramCategory();
            case SlideCategories.COMPARE_ITEMS:
                return new CompareItemsCategory();
            case SlideCategories.SECTION_BREAK:
                return new SectionBreakCategory();
            default:
                return new ListCategory();
        }
    }

    static buildCategoryPrompt(excludeTitle = false) {
        const categoryPickerPrompt = Object.values(SlideCategories).map(type => {
            if (excludeTitle && type === SlideCategories.TITLE) {
                return null;
            }
            let category = this.getCategory(type);
            return `
            Category: "${category.type}"
            When to use: ${category.description}`;
        }).join("\n");
        return categoryPickerPrompt;
    }
}

